module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('div', {
    staticClass: "textfield mt-5",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "id": "output"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    staticClass: "input-area w-50 form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter your notes here..."
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "save btn rounded-0",
    on: {
      "click": _vm.saveNote
    }
  }, [_vm._v("\n      Save\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "notes"
  }, _vm._l((_vm.notes), function(note, index) {
    return _c('div', {
      key: index,
      staticClass: "notes-div"
    }, [_c('div', {
      staticClass: "note-div"
    }, [_c('span', {
      staticClass: "note"
    }, [_vm._v(_vm._s(note.note))]), _vm._v(" "), _c('div', {
      staticClass: "note-details"
    }, [_c('div', {
      staticClass: "time-and-delete"
    }, [_c('div', {
      staticClass: "note-owner-and-time"
    }, [_c('span', {
      staticClass: "note-owner"
    }, [_vm._v(_vm._s(note.created_by.first_name + " " + note.created_by.last_name))]), _vm._v(" "), _c('span', {
      staticClass: "dot"
    }, [_vm._v(".")]), _vm._v(" "), _c('span', {
      staticClass: "note-time"
    }, [_vm._v(_vm._s(_vm._f("moment")(("" + (note.created)), "DD/MM/YY, h:mm a")))])]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "remove fa fa-trash-o pointer",
      on: {
        "click": function($event) {
          return _vm.deleteNote(index)
        }
      }
    })])])])])])
  }), 0), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin-top": "25px",
      "margin-left": "-10px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50, 100],
      "total": _vm.total_pages,
      "layout": "sizes, prev, pager, next",
      "page-size": _vm.offset
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81c129ba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/AdspotNotes.vue
// module id = 705
// module chunks = 2